<h2 mat-dialog-title>Filter</h2>
<mat-dialog-content class="on-background2">
  <form [formGroup]="filterForm">
    <div class="country-intersect">
      <mat-checkbox formControlName="countryIntersection">Country Intersection</mat-checkbox>
    </div>
    @for (item of configList; track item) {
      <div class="control-item">
        <app-improved-select
          formControlName="{{ item.controlName }}"
          (click)="item.loadFn()"
          (keydown)="item.loadFn()"
          [optionList]="item.options()"
          [multiple]="item.multiple ?? false"
          [showChips]="true"
          [label]="item.label"
          [displayKey]="item.displayKey"
          [loading]="item.loading?.() ?? false"
        >
        </app-improved-select>
      </div>
    }

    <mat-form-field class="control-item-mt">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate formControlName="dateFrom" placeholder="Created From" />
        <input matEndDate formControlName="dateTo" placeholder="Created To" />
      </mat-date-range-input>
      <mat-hint class="date-picker-hint-text">YYYY-MM-DD – YYYY-MM-DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

      @if (filterForm.controls.dateFrom.hasError('matStartDateInvalid')) {
        <mat-error>Invalid start date</mat-error>
      }
      @if (filterForm.controls.dateTo.hasError('matEndDateInvalid')) {
        <mat-error>Invalid end date</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="onClear()">Clear filters</button>
  <button mat-flat-button (click)="onSubmit()">Submit</button>
</mat-dialog-actions>
